if (!customElements.get('trust-indicators')) {
  class TrustIndicators extends HTMLElement {
    constructor() {
      super();


      this.initSlider();
    }

    initSlider() {
      var swiperArea = this.querySelector('.swiper');
      // The bar layout (homepage) has no slider.
      if (!swiperArea) return;
      // Product pages ask for two per view on phones (data-mobile-per-view).
      var mobilePerView = parseInt(this.dataset.mobilePerView, 10) || 1;
      this.slider = new Swiper(swiperArea, {
        slidesPerView: mobilePerView,
        autoplay: { delay: 3000, disableOnInteraction: false },
        loop: true,
        // Product layout puts the slides in a <ul role="list">, where Swiper's default
        // role=group broke the list; a <div> wrapper keeps group.
        a11y: { slideRole: swiperArea.querySelector('ul.swiper-wrapper') ? 'listitem' : 'group' },
        spaceBetween: mobilePerView > 1 ? 12 : 21,
        breakpoints: {
          750: {
            spaceBetween: 21,
            slidesPerView: 3
          },
          990: {
            spaceBetween: 21,
            slidesPerView: 4
          }
        }
      });
    }
  }

  customElements.define('trust-indicators', TrustIndicators);
}
